import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap mx-auto mx-1 px-1 lg:mx-96 lg:px-24 sm:px-1 overflow-hidden" }
const _hoisted_2 = { class: "my-1 px-1 pt-1 w-1/2 grid-cols-1 lg:grid-cols-2 overflow-hidden" }
const _hoisted_3 = { class: "pricing-item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("li", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ribbon" })
], -1)
const _hoisted_5 = { class: "pricing-header px-1 lg:mx-24 lg:px-7" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("sup", null, "$"),
  /*#__PURE__*/_createTextVNode("2.99 ")
], -1)
const _hoisted_7 = { class: "my-1 px-1 pt-1 w-1/2 overflow-hidden" }
const _hoisted_8 = { class: "pricing-item active" }
const _hoisted_9 = { class: "ribbon" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  height: "30",
  width: "140"
}, [
  /*#__PURE__*/_createElementVNode("polygon", {
    class: "ribbon__bends",
    points: "0 20,10 30,20 20",
    style: {"fill":"currentColor","stroke":"red","stroke-width":"0"}
  }),
  /*#__PURE__*/_createElementVNode("polygon", {
    class: "ribbon__bends",
    points: "120 20,130 30,140 20",
    style: {"fill":"currentColor","stroke":"red","stroke-width":"0"}
  }),
  /*#__PURE__*/_createElementVNode("polygon", {
    class: "ribbon__body",
    points: "120 0,140 20,0 20, 20 0",
    style: {"fill":"currentColor"}
  })
], -1)
const _hoisted_11 = { class: "ribbon__text" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("li", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-gem" })
], -1)
const _hoisted_13 = { class: "pricing-header px-1 lg:mx-24 lg:px-7" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("sup", null, "$"),
  /*#__PURE__*/_createTextVNode("29.99 ")
], -1)
const _hoisted_15 = { href: "#" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", null, [
          _hoisted_4,
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.labels_monthly), 1),
            _hoisted_6
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.labels_recommended), 1)
        ]),
        _createElementVNode("ul", null, [
          _hoisted_12,
          _createElementVNode("li", _hoisted_13, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.labels_yearly), 1),
            _hoisted_14
          ])
        ])
      ])
    ]),
    _createElementVNode("button", {
      class: "btn navbar-toggler btn-medium",
      type: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectPlan && _ctx.selectPlan(...args)))
    }, _toDisplayString(_ctx.actions_select_plan), 1),
    _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.actions_continue_free), 1)
  ]))
}